var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationProvider", {
    ref: "autocompleteValidator",
    attrs: {
      rules: _vm.validatorRules,
      name: _vm.validationName,
      vid: _vm.validationName,
      tag: "div",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c(
              "div",
              {
                class: [
                  { "error-styles": errors[0] },
                  { "hidden-field": _vm.hidden },
                  { "disabled-field": _vm.disabled },
                  "lf-autocomplete-container",
                ],
              },
              [
                _c(
                  "span",
                  {
                    class: [
                      { "required-field": _vm.requiredField },
                      "label-text",
                    ],
                  },
                  [_vm._v(_vm._s(_vm.$attrs.label))]
                ),
                _c(
                  "v-autocomplete",
                  _vm._g(
                    {
                      key: _vm.componentKey,
                      ref: "vAutocomplete",
                      class: [{ "error-styles": errors[0] }, "lf-autocomplete"],
                      attrs: {
                        value: _vm.innerValue,
                        height: _vm.height,
                        items: _vm.loadedItems,
                        chips: _vm.chips,
                        "single-line": "",
                        "deletable-chips": _vm.deletableChip,
                        multiple: _vm.multiple,
                        "append-icon": _vm.icons.arrowDown,
                        "error-messages": errors,
                        "hide-details": "",
                        attach: _vm.attach,
                        clearable: _vm.clearable,
                        id: _vm.$attrs.id,
                        name: _vm.$attrs.name,
                        placeholder: _vm.computedPlaceholder,
                        "item-text": _vm.itemName,
                        "item-value": _vm.itemValue,
                        "return-object":
                          _vm.hasRelatedField || _vm.returnObject,
                        "clear-icon": _vm.icons.clearIcon,
                        filter: _vm.customFilter,
                        "search-input": _vm.search,
                        autocomplete: "off",
                        disabled: _vm.disabled,
                        "menu-props": _vm.menuConfiguration,
                      },
                      on: {
                        "update:searchInput": function ($event) {
                          _vm.search = $event
                        },
                        "update:search-input": function ($event) {
                          _vm.search = $event
                        },
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.update.apply(null, arguments)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          _vm.chips
                            ? {
                                key: "selection",
                                fn: function ({ item, index }) {
                                  return [
                                    index < _vm.visibleChips
                                      ? _c(
                                          "v-chip",
                                          {
                                            attrs: { close: "" },
                                            on: {
                                              "click:close": function ($event) {
                                                return _vm.removechip(item)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: {
                                                  title: item[_vm.itemName],
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item[_vm.itemName])
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    index === _vm.visibleChips
                                      ? _c("span", { staticClass: "others" }, [
                                          _vm._v(
                                            "+" +
                                              _vm._s(
                                                _vm.value.length -
                                                  _vm.visibleChips
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "components.autocomplete.other"
                                                )
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                },
                              }
                            : null,
                          {
                            key: "no-data",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "no-results-message" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "components.no_results.no_search_results_text"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          _vm.showIcon
                            ? {
                                key: "item",
                                fn: function ({ item }) {
                                  return [
                                    _c("div", [
                                      _c("span", {
                                        class: `item-icon ${item.icon}`,
                                      }),
                                      _c("span", [
                                        _vm._v(_vm._s(item[_vm.itemName])),
                                      ]),
                                    ]),
                                  ]
                                },
                              }
                            : null,
                          _vm.showSelectAll
                            ? {
                                key: "prepend-item",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item",
                                      {
                                        staticClass: "select-all",
                                        on: { click: _vm.toggleSelectAll },
                                      },
                                      [
                                        _c(
                                          "v-list-item-action",
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "select-all-icon",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.allSelected
                                                      ? _vm.icons.close
                                                      : _vm.icons.selectAllEmpty
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(_vm._s(_vm.selectAllText)),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider"),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    },
                    _vm.$listeners
                  )
                ),
                _c("div", { staticClass: "messages-container" }, [
                  errors.length
                    ? _c("span", { staticClass: "alert-message" }, [
                        _vm._v(_vm._s(errors[0])),
                      ])
                    : _c("span", { staticClass: "help-message" }, [
                        _vm._v(_vm._s(_vm.helpText)),
                      ]),
                ]),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }